module.exports = __webpack_public_path__ + "static/media/img3-3.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/P/img3-3.png
// module id = 1606
// module chunks = 3